"use client";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useNotifyDialog } from "../Providers/NotifyDialogContext";
import { EmailCadence } from "@/interfaces/campaign";

export default function NotificationFormContent() {
  const { emailCadence, setEmailCadence } = useNotifyDialog();

  return (
    <>
      <input type="hidden" name="emailCadence" value={emailCadence} />
      <FormControl fullWidth className="mt-2">
        <InputLabel id="notification-cadence">Notify By Email</InputLabel>
        <Select
          labelId="notification-cadence"
          id="notification-cadence"
          value={emailCadence}
          label="Notify By Email"
          onChange={(e) => setEmailCadence(e.target.value as EmailCadence)}
        >
          <MenuItem value={EmailCadence.Unsubscribed}>Unsubscribed</MenuItem>
          <MenuItem value={EmailCadence.Daily}>Daily</MenuItem>
          <MenuItem value={EmailCadence.Weekly}>Weekly</MenuItem>
        </Select>
      </FormControl>
    </>
  );
}
